// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__8MOQh","actionsCol":"EnrolledClinics_actionsCol__2V4JN"};